document.addEventListener('DOMContentLoaded', function () {
  const mount = document.getElementById('compare-table-mount');
  if (!mount) return;
  const key = 'energea_compare_v1';
  let items = [];
  try {
    items = JSON.parse(sessionStorage.getItem(key) || '[]');
  } catch (e) {
    items = [];
  }
  if (!items.length) {
    mount.innerHTML = '<p>No products selected. <a href="/collections/all">Back to shop</a></p>';
    return;
  }

  const rows = [
    ['', (p) => '<img src="' + p.featured_image + '" alt="" width="120"/>'],
    ['Product name', (p) => p.title],
    ['Price', (p) => p.price],
    ['Battery capacity', (p) => p.battery_capacity || '—'],
    ['Magnetic attachment', (p) => p.magnetic_attachment || '—'],
    ['Wireless charging', (p) => p.wireless_charging || '—'],
    ['Device compatibility', (p) => p.device_compatibility || '—']
  ];

  let html = '<table class="compare-table"><thead><tr>';
  items.forEach((p) => {
    html += '<th scope="col">' + (p.title || '') + '</th>';
  });
  html += '</tr></thead><tbody>';

  rows.forEach(function (row) {
    html += '<tr><th scope="row">' + row[0] + '</th>';
    items.forEach(function (p) {
      html += '<td>' + row[1](p) + '</td>';
    });
    html += '</tr>';
  });

  html += '</tbody></table>';
  html += '<p><a class="button" href="javascript:history.back()">Compare with other products</a></p>';
  mount.innerHTML = html;
});
